import { Button, Dialog } from '@mui/material';
import { useState } from 'react';
import { MdOutlineCloudUpload } from 'react-icons/md';
import './../components/UserDetails/UserDetails.scss';
import './OnboardingModal.scss';
import { uploadFile } from '@widgets/UserManagementTable/api';
import snackbarStore from '@widgets/MainLayout/store/snackbar-store';

const OnboardingModal: React.FC<{ fdId: string; openPopup: boolean; setOpenPopup: (value: boolean) => void }> = ({
    fdId,
    openPopup,
    setOpenPopup,
}) => {
    const [file, setFile] = useState<File | null>(null);
    const { setSnackbarMessage } = snackbarStore();

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setFile(event.target.files[0]);
        }
    };

    const handleUpload = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!file) {
            alert('Please select a file first.');
            return;
        }
        try {
            const response = await uploadFile(fdId, file);
            if (response) {
                setSnackbarMessage('File uploaded successfully and being processed');
                setOpenPopup(false);
            }
        } catch (error) {
            setSnackbarMessage('Failed to upload and process the file for customer onboarding');
        }
    };

    return (
        <>
            <Dialog
                open={openPopup}
                onClose={() => setOpenPopup(false)}
                maxWidth='sm'
                fullWidth
            >
                <div className='email-dialog-header'>
                    <div className='email-dialog-title'>Upload the file to add</div>
                </div>

                <div className='upload-box'>
                    <div className='upload-icon'></div>
                    <MdOutlineCloudUpload className='w-12 h-12 text-blue-500' />
                    <p>Drag your file(s) to start uploading</p>
                    <span style={{ color: 'grey', fontSize: 'small' }}>OR</span>
                    <label className='browse-button'>
                        <input
                            type='file'
                            hidden
                            onChange={handleFileChange}
                        />
                        Browse files
                    </label>
                    {file && (
                        <div className='selected-file'>
                            <p style={{ color: 'grey', fontSize: 'small' }}>{file.name}</p>
                        </div>
                    )}
                </div>

                <div className='email-dialog-header2'>
                    <div
                        className='email-dialog-title'
                        style={{ color: 'gray' }}
                    >
                        Only support CSV files
                    </div>
                </div>

                <div className='email-dialog-content'>
                    <div className='email-dialog-footer'>
                        <Button
                            style={{ marginLeft: '15px' }}
                            variant='outlined'
                            onClick={() => setOpenPopup(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginLeft: '20px' }}
                            variant='contained'
                            color='primary'
                            onClick={handleUpload}
                        >
                            Upload
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default OnboardingModal;
